import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-product-promotion',
  templateUrl: './product-promotion.component.html',
  styleUrls: ['./product-promotion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ProductPromotionComponent {
  @Input() promotion: boolean;
  @Input() isBlackDealsEnabled: boolean;
  @Input() msrpDiscount: string | number;
  @Input() fromProductCard: boolean = false;
  @Input() hasFixedHeight: boolean = false;
  @Input() hasVolumePrice: boolean = false;
  @Input() volumePriceQuantity: string | number;
  @Input() volumePricePercentage: string | number;
  @Input() multiRowLabel: boolean = false;
  @Input() roundedLabels: boolean = false;
  @Input() serie: boolean;
  @Input() isNewDesign: boolean;
}
